export default __webpack_public_path__ + "static/media/Flag_of_Cuba.937190a9.svg";